import {Component} from 'react'
import {products} from './data'
import ProductList from './components/ProductList'
import ProductDetail from './components/ProductDetail'
import './App.css'

class App extends Component {
  state = {
    selectedProduct: null,
    searchText: '',
    category: 'All',
    status: 'All',
    sortBy: 'name',
  }

  onSearchChange = event => {
    this.setState({searchText: event.target.value})
  }

  onCategoryChange = event => {
    this.setState({category: event.target.value})
  }

  onStatusChange = event => {
    this.setState({status: event.target.value})
  }

  onSortChange = event => {
    this.setState({sortBy: event.target.value})
  }

  getFilteredProducts = () => {
    const {searchText, category, status, sortBy} = this.state

    const filteredProducts = products
      .filter(product =>
        product.name.toLowerCase().includes(searchText.toLowerCase()),
      )
      .filter(product =>
        category === 'All' ? true : product.category === category,
      )
      .filter(product => (status === 'All' ? true : product.status === status))

    if (sortBy === 'name') {
      filteredProducts.sort((a, b) => a.name.localeCompare(b.name))
    } else {
      filteredProducts.sort((a, b) => new Date(b.date) - new Date(a.date))
    }

    return filteredProducts
  }

  render() {
    const {selectedProduct, searchText, category, status, sortBy} = this.state

    return (
      <div className="container">
        <h1>Products Store</h1>

        {selectedProduct ? (
          <ProductDetail
            product={selectedProduct}
            onBack={() => this.setState({selectedProduct: null})}
          />
        ) : (
          <>
            <input
              type="search"
              placeholder="Search products..."
              value={searchText}
              onChange={this.onSearchChange}
              className="search-input"
            />

            <div className="filters">
              <select value={category} onChange={this.onCategoryChange}>
                <option value="All">All Categories</option>
                <option value="Audio">Audio</option>
                <option value="Phones">Phones</option>
                <option value="Watches">Watches</option>
                <option value="Cameras">Cameras</option>
                <option value="Laptops">Laptops</option>
              </select>

              <select value={status} onChange={this.onStatusChange}>
                <option value="All">All Status</option>
                <option value="In Stock">In Stock</option>
                <option value="Limited Stock">Limited Stock</option>
                <option value="Out of Stock">Out of Stock</option>
              </select>

              <select value={sortBy} onChange={this.onSortChange}>
                <option value="name">Sort by Name</option>
                <option value="date">Sort by Date</option>
              </select>
            </div>

            <ProductList
              products={this.getFilteredProducts()}
              onSelect={product => this.setState({selectedProduct: product})}
            />
          </>
        )}
      </div>
    )
  }
}

export default App
